// Permissions for translations served by LocalizationPermission
// (/translation/ and /translation-models/ endpoints) - the backend checks
// `view_localization` (GET) and `change_localization` (PATCH) there.
export const translationPermissionsConst = {
  view: {
    value: "view_localization",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu tłumaczeń!",
  },
  update: {
    value: "change_localization",
    errorMsg: "Użytkownik nie ma uprawnień do edycji tłumaczeń!",
  },
};

// Permissions for the localization.Translation model (i18n translations),
// enforced by CpDjangoModelPermissions on the /i18n/translations/ endpoint.
export const i18nTranslationPermissionsConst = {
  view: {
    value: "view_translation",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu tłumaczeń!",
  },
  add: {
    value: "add_translation",
    errorMsg: "Użytkownik nie ma uprawnień do dodania tłumaczenia!",
  },
  update: {
    value: "change_translation",
    errorMsg: "Użytkownik nie ma uprawnień do edycji tłumaczeń!",
  },
  delete: {
    value: "delete_translation",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania tłumaczeń!",
  },
};
